import { Box, IconButton, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CloseIcon from '@mui/icons-material/Close'
import dayjs from 'dayjs'
import { styles } from './InviteeList.styles'

interface Props {
  dueDate?: string | null
  onDismiss: () => void
}

export const DueDateNotice = ({ dueDate, onDismiss }: Props): JSX.Element => (
  <Box data-testid='p2pInviteNotice' sx={styles.notice}>
    <InfoOutlinedIcon fontSize='small' />
    <Typography variant='body2' sx={styles.noticeText}>
      {dueDate != null
        ? `The data collection window closes on ${dayjs(dueDate).format('MMMM D, YYYY')}. Make sure all users are invited before this date.`
        : 'Make sure all users are invited before the data collection window closes.'}
    </Typography>
    <IconButton size='small' aria-label='dismiss' data-testid='p2pDismissNotice' onClick={onDismiss} sx={styles.noticeDismiss}>
      <CloseIcon fontSize='small' />
    </IconButton>
  </Box>
)
